import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { TournamentsComponent } from "../../components/tournaments"

export const TournamentsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <TournamentsComponent />
    </DefaultPageComp>
  </>
}